import React, { Component } from 'react';
import { StyledMenuItem } from 'components/Global/Card/styled.js';
import { SendIcon } from './styled.js';

export default class Send extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: false,
    };
    this.select = this.select.bind(this);
  }

  select(e) {
    e.preventDefault();
    const { callback } = this.props;
    if (callback) callback();
    // TODO: This is temporary, as this button is only triggering a coming soon modal
    // this.setState({
    //   selected: !this.state.selected,
    // });
  }

  render() {
    return (
      <StyledMenuItem onClick={this.select} selected={this.state.selected}>
        <SendIcon selected={this.state.selected} />
      </StyledMenuItem>
    );
  }
}
